<div class="columns is-vcentered">
  <div  class="column">
    <figure id="LogoDolomitiEmergency">
      <img src="/Images/dolomiti-emergency.png" alt="Dolomiti Emergency" />
    </figure>
  </div>
  <div class="column is-narrow">
    <div class="is-flex is-align-items-center">
      <ng-container *ngIf="authenticated$ | async as authenticated; else notAuth">
       
      </ng-container>
      <ng-template #notAuth>
        <a class="button is-ghost" i18n="@@loginIfSocio" (click)="login()">Già registrato? Effettua l'accesso</a>
      </ng-template>
      <a href="/en" title="English" *ngIf="locale == 'it'; else eng_locale">
        <img class="img-flag" src="/Images/gb.png" alt="English" />
      </a>
      <ng-template #eng_locale>
        <a href="/it" title="Italiano">
          <img class="img-flag" src="/Images/it.png" alt="Italiano" />
        </a>
      </ng-template>
    </div>
  </div>
</div>

<ng-container *ngIf="data$ | async as data">
  <div class='section profile-heading' >
    <div class='columns columns-dati-socio'>
      <!--is-vcentered-->
      <div class='column column-rif is-4-tablet is-8-mobile name'>
        <p class='title is-bold'>{{data.nomeCompleto}}</p>
        <p class="subtitle is-uppercase">Socio {{data | tipoSocio}}</p>
        <div class="field has-addons">
          <p class="control">
            <a class="button is-primary has-text-weight-semibold is-uppercase" style="margin: 0.375rem 0" [routerLink]="['/area-utente', 'pagamento']">
              <span i18n="@@renewInsurance">Versa la quota</span>
            </a>
          </p>
          <p class="control">
            <a class="button is-uppercase" style="margin: 0.375rem 0" (click)="passwordReset()">
              <span class="is-size-7" i18n="@@changePassword">Cambio password</span>
            </a>
          </p>
          <p class="control">
            <a class="button is-uppercase"
             style="margin: 0.375rem 0" (click)="logOut()"><span class="is-size-7">Logout</span></a>
          </p>
        </div>
      </div>
      <div class='column column-id-socio is-2-tablet is-6-mobile has-text-centered'>
        <p class='stat-val'>{{data.id}}</p>
        <p class='stat-key' i18n="@@memberId">id socio</p>
      </div>
      <div class='column column-id-tessera is-2-tablet is-6-mobile has-text-centered'>
        <p class='stat-val'>{{data.idTessera && data.idTessera > 0 ? data.idTessera : 'N/A'}}</p>
        <p class='stat-key' i18n="@@cardId">numero tessera</p>
      </div>
      <div class='column column-scadenza is-4-tablet is-4-mobile has-text-right'>
        <p class='stat-val is-uppercase'>
          <span class="tag is-large is-danger" *ngIf="data.temporary">
            <span i18n="@@notActivated">temporaneo</span>
          </span>
          <span class="tag is-large is-success" *ngIf="!data.temporary && (data | assicurato)">
            <span i18n="@@validInsurance">valida</span>
          </span>
          <span class="tag is-large is-danger" *ngIf="! data.temporary && !(data | assicurato)">
            <span i18n="@@notValidInsurance">scaduta</span>
          </span>
        </p>
        <ng-container *ngIf="!data.temporary; else socioPlaceHolder">
          <p class='stat-key' i18n="@@insurance">assicurazione</p>
          <p *ngIf="(data | assicurato)"><span i18n="@@insuranceExpire">scadenza:</span>&nbsp;<span class="has-text-weight-semibold date-field">{{data.fineValidita | date}}</span></p>
          <p *ngIf="!(data | assicurato)"><span i18n="@@insuranceExpiredAt">scaduta il:</span>&nbsp;<span class="has-text-weight-semibold has-text-danger date-field">{{data.fineValidita | date}}</span></p>
        </ng-container>
        <ng-template #socioPlaceHolder>
          <p class='stat-key' i18n="@@member">socio</p>
        </ng-template>
      </div>
    </div>
  </div>
  <div class='profile-options is-fullwidth px-5'>
    <div class='tabs is-centered is-medium'>
      <ul>
        <li class='link' routerLinkActive="is-active">
          <a [routerLink]="['/area-utente', 'miei-dati']">
            <span class='icon'>
              <i class="fas fa-address-card"></i>
            </span>
            <span i18n="@@myData">I miei dati</span>
          </a>
        </li>
        <li class='link' routerLinkActive="is-active">
          <a [routerLink]="['/area-utente', 'rinnovi']">
            <span class='icon'>
              <i class="fas fa-calendar-check"></i>
            </span>
            <span i18n="@@myRenewal">Rinnovi</span>
          </a>
        </li>
        <li class='link' routerLinkActive="is-active">
          <a [routerLink]="['/area-utente', 'pagamenti']">
            <span class='icon'>
              <i class="fas fa-coins"></i>
            </span>
            <span i18n="@@myPayment">Pagamenti</span>
          </a>
        </li>
        <li class='link' routerLinkActive="is-active">
          <a [routerLink]="['/area-utente', 'gruppo']">
            <span class='icon'>
              <i class="fas fa-users"></i>
            </span>
            <span i18n="@@myGroup">Il mio gruppo</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</ng-container>

<div *ngIf="isLoggedWithouthIdSocio" class="title has-text-centered">Utente senza id socio</div>

<change-password [(visible)]="passwordResetting"></change-password>
